import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { inspectContentEditorDocument, inspectContentEditorInsertion } from '@mts/shared/contentEditorProfiles';
import { inspectContentEditorLocks } from '@mts/shared/contentEditorLocks';

/** One transaction boundary covers typing, commands, paste, drop, AI, and history. */
export function createContentEditorPolicy({ getProfile, isControlledLoad, onRejected }) {
  return Extension.create({
    name: 'contentEditorPolicy',
    addProseMirrorPlugins() {
      return [new Plugin({
        key: new PluginKey('mtsContentEditorPolicy'),
        filterTransaction(transaction, state) {
          if (!transaction.docChanged) return true;
          const profile = getProfile();
          if (isControlledLoad?.()) {
            const result = inspectContentEditorDocument(transaction.doc.toJSON(), profile);
            if (!result.valid) onRejected?.(result.issues);
            return result.valid;
          }
          if (profile.readOnly) {
            onRejected?.([{ code: 'read-only', severity: 'error', message: 'This document is read-only.' }]);
            return false;
          }
          const result = inspectContentEditorDocument(transaction.doc.toJSON(), profile);
          const locks = inspectContentEditorLocks(state.doc.toJSON(), transaction.doc.toJSON(), { authorLocks: profile.mode === 'template' });
          const insertionIssues = inspectContentEditorInsertion(state.doc.toJSON(), transaction.doc.toJSON(), profile);
          const issues = [...result.issues, ...locks, ...insertionIssues];
          const valid = result.valid && !locks.length && !insertionIssues.length;
          if (!valid) onRejected?.(issues);
          return valid;
        },
      })];
    },
  });
}
